module.exports = __webpack_public_path__ + "static/media/ballrom.f9459717.jpg";